import { render, staticRenderFns } from "./Retained.vue?vue&type=template&id=31b9736f&scoped=true&"
import script from "./Retained.vue?vue&type=script&lang=js&"
export * from "./Retained.vue?vue&type=script&lang=js&"
import style0 from "./Retained.vue?vue&type=style&index=0&id=31b9736f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b9736f",
  null
  
)

component.options.__file = "Retained.vue"
export default component.exports